import { render } from "./DownloadIcon.vue?vue&type=template&id=42f4f19b&ts=true"
import script from "./DownloadIcon.vue?vue&type=script&lang=ts"
export * from "./DownloadIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__